import { render, staticRenderFns } from "./CopyForm.vue?vue&type=template&id=0becb671&"
import script from "./CopyForm.vue?vue&type=script&lang=js&"
export * from "./CopyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports